import { AppModule } from 'app/module';
import './styles.scss';

export class CompanyCardImage extends AppModule {
    domBindings() {
        return {
            logo: '.m-companyCardImage__logo',
            image: '.m-companyCardImage__image',
            previewVideo: '.m-companyCardImage__previewVideo',
            videoBadge: '.m-companyCardImage__videoBadge',
            brandingBadge: '.m-companyCardImage__brandingBadge',
            link: '.m-companyCardImage__link',
        };
    }

    getPropsFromDom() {
        return {
            hasBranding: this.dom.el.classList.contains('m-companyCardImage--branding'),
            logo: this.dom.logo.src,
            title: this.dom.image ? this.dom.image.getAttribute('alt') : '',
            previewVideo: this.dom.previewVideo ? this.dom.previewVideo.getAttribute('data-previewVideo') : false,
            image: this.dom.image?.src,
            indexEvent: this.dom.link ? this.dom.link.getAttribute('data-event') : '',
            brandingSolution: !!this.dom.videoBadge,
            employerPagePlus: !!this.dom.brandingBadge && !this.dom.videoBadge,
            url: this.dom.link ? this.dom.link.href : '',
        };
    }

    domEvents() {
        if (this.dom.previewVideo !== null) {
            // mouse devices
            this.dom.el.addEventListener('mouseover', async () => this.startVideo());
            this.dom.el.addEventListener('mouseleave', () => this.pauseVideo());

            // touch devices
            this.dom.el.addEventListener('touchstart', async () => this.startVideo());
            this.dom.el.addEventListener('touchend', () => this.pauseVideo());
        }
    }

    // #delegation ready
    // eventBindings() {
    //     return {
    //         mouseover: () => this.startVideo(),
    //         mouseout: () => this.pauseVideo(),
    //     };
    // }

    async startVideo() {
        if (this.dom.previewVideo !== null && this.previewVideoPlaying !== true) {
            try {
                await this.dom.previewVideo.play();
                this.dom.previewVideo.classList.add('m-companyCardImage__previewVideo--visible');
                this.previewVideoPlaying = true;
            } catch {
                this.previewVideoPlaying = false;
            }
        }
    }

    pauseVideo() {
        if (this.dom.previewVideo !== null
            && !this.dom.previewVideo.paused
            && this.previewVideoPlaying === true) {
            this.dom.previewVideo.classList.remove('m-companyCardImage__previewVideo--visible');
            this.dom.previewVideo.pause();
            this.previewVideoPlaying = false;
        }
    }
}
